import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"

export enum TextBuildingBlockSearchScope {
    id = "id",
    text = "text",
}

export interface IGetTextBuilidngBlockParams {
    search?: string
    scope?: TextBuildingBlockSearchScope
    pageSize?: number
    pageNumber?: number
    notFormattedOnly?: boolean
}

export interface IGetTextBuildingBlockDto {
    id: Guid
    textBlockId: string
    text: string
    textFormatting: boolean
    links: IApiLink[]
}

export interface ICreateTextBuildingBlockDto {
    textBlockId: string
    text: string
    textFormatting: boolean
}
export interface IUpdateTextBuildingBlockDto {
    textBlockId: string
    text: string
}

export default class TextBuildingBlock {
    id: Guid
    textBlockId: string
    text: string
    textFormatting: boolean
    linkUpdate?: IApiLink
    linkDelete?: IApiLink

    constructor(dto: IGetTextBuildingBlockDto) {
        this.id = dto.id
        this.textBlockId = dto.textBlockId
        this.text = dto.text
        this.textFormatting = dto.textFormatting
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsTextBuildingBlock && lnk.rel === ApiLinkRel.update)
        this.linkDelete = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsTextBuildingBlock && lnk.rel === ApiLinkRel.delete)
    }
}
